<template>
    <div id="inbox_page" class="no_top_margin">
      <div class="md-layout" style="height:calc(100vh - 100px);">
        <div class="md-layout-item md-size-30 threads_wrapper"><Threads @open_thread="open_thread" @empty="this.$route.go('/inboxIndex')" /></div>
        <div class="md-layout-item md-size-50 chat_wrapper" id="chat_area_wrapper" :data-id="openChat"><Chat v-if="openChat > 0" :key="openChat" :user_id="openChat" ref="chatbox" /></div>
        <div class="md-layout-item md-size-20" id="chat_user_details_wrapper"><ChatUserDetails v-if="openChat > 0 && !isNull(openChatUser)" :key="openChat" :userData="openChatUser" /></div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Threads from '@/components/inbox/threads.vue'
import ChatUserDetails from '@/components/inbox/user_details.vue'
import Chat from '@/components/chat.vue'

export default {
    props: ["user_data"],
  components: { Threads, Chat, ChatUserDetails },
  data(){
      return {
          openChat: null,
          openChatUser: null,
          
      }
  },
  methods: {
      open_thread(id, user){
          this.openChat = id;
          this.openChatUser = user;
          console.log(this.openChatUser)
      },


    parse_user_channel(data)
    {
      if (this.openChat == data.uid_from)
      { 
            this.$refs.chatbox.pushMessage({ author: (data.uid_from == this.user_data.id ? 'me' : data.uid_from), type: 'text', data: { text: data.msg } });
      }
    },

  },
  mounted(){
    // console.log(this.$route);
       if (this.$route.params.id > 0)
        {
            this.api({ action: 'user/get_details', data: { user_id: this.$route.params.id } }, (data) => { 
                
                this.open_thread(data.data.id, data.data); 
            });
        }
         if(this.$route.query.artist_id > 0)
        {
        //  alert(this.$route.query.artist_id)
           this.api({ action: 'user/results', data: { artist_id: this.$route.query.artist_id } }, (data) => { 
                
                this.open_thread(data.data.id, data.data); 
            });
        }
         if(this.$route.query.media_id > 0)
        {
           this.api({ action: 'user/results', data: { media_id: this.$route.query.media_id } }, (data) => { 
                
                this.open_thread(data.data.id, data.data); 
            });
        }
        // console.log(this.$store.user);
        // console.log(this.user_data);
        //this.$pnSubscribe({ channels: ['user_cnl_' + this.user_data.id] });
        //this.$pnGetMessage('user_cnl_' + this.user_data.id, this.parse_user_channel);

      this.$bus.$on('new-msg', this.parse_user_channel);
  },
  beforeUnmount() {
    this.$bus.$off('new-msg');
  },
}
</script>

<style lang="scss" >
#inbox_page { }
#inbox_page .threads_wrapper { background: #4c4c4c; color:#fff; }
#inbox_page #chat_area_wrapper .sc-chat-window { height: calc(100vh - 100px) !important; max-height: 100% !important; }
#inbox_page .sc-message-list { background: #f0f0f0 !important; } 
#chat_user_details_wrapper { background: #fff;}
</style>